<div class="row">
    <div class='col-sm-12'>
        <div style='padding:1.0em;' [ngClass]="{'inactive': !session.userAttendance}">
            <div class="pull-right" *ngIf="session.userAttendance">
                <div class='inline' style='margin-left:0.5em;' *ngIf="session.integrations.zoom">
                    <app-open-button-sm (click)="openZoom()">Zoom</app-open-button-sm>
                </div>
                <div class='inline' style='margin-left:0.5em;' *ngIf="session.joinUrl">
                    <app-presentation-button [isActive]="true" (click)="open(session.joinUrl)">Join</app-presentation-button>
                </div>
            </div>
            
            <div style='font-size:1.2em;'>{{session.name}}</div>
            
            <div style='font-size:0.9em;margin-top:0.5em;'>
                <div *ngIf="isOneDayEvent">
                    {{session.startDate | date:"h:mm:ss a"}}
                    <span *ngIf="session.endDate"> - {{session.endDate | date:"h:mm:ss a"}}</span>
                </div>
                <div *ngIf="!isOneDayEvent">
                    {{session.startDate | date:"EEEE, MMMM d, y h:mm:ss a"}}
                    <span *ngIf="isOneDaySession && session.endDate"> - {{session.endDate | date:"h:mm:ss a"}}</span>
                    <span *ngIf="!isOneDaySession && session.endDate"> - {{session.endDate | date:"EEEE, MMMM d, y h:mm:ss a"}}</span>
                </div>
                <!-- <div>{{session.status.name}}</div> -->
                
                <div style="margin-top:0.5em;" *ngIf="session.description">{{session.description}}</div>
                
                <div class="clearfix"></div>
                
                <div style='margin-top:1.0em;' *ngIf="session.userAttendance && session.integrations.docebo && session.integrations.docebo.showOpen">
                    <div class="group-title" style='margin-top:2.0em;'>Additional Materials</div>
                    
                    <div style='margin-top:1.0em;'>
                        <app-open-button-sm (click)="openDocebo()">Access Additional Materials</app-open-button-sm>
                    </div>
                </div>
            </div>
            <!-- <pre>{{session | json}}</pre> -->
        </div>
    </div>
</div>

<div class='row' *ngIf='loadingError'>
    <div class='col-sm-12 text-center error'>
        <div>{{loadingError}}</div>
    </div>
</div>
